import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2, Check, Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";

const Row = ({ c, i, onChanged }) => {
  const [v, setV] = useState(c.name);
  const [busy, setBusy] = useState(false);
  const act = async (fn, msg) => { setBusy(true); try { const r = await fn(); toast.success(msg(r)); onChanged(); } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر التنفيذ"); } finally { setBusy(false); } };
  const rename = () => act(() => api.renameRecordCategory(c.name, v.trim()), (r) => `تمت إعادة التسمية وتحديث ${r.updated} سجل`);
  const del = () => { if (window.confirm(`حذف «${c.name}»؟ ستُنقل سجلاته (${c.count}) إلى «أخرى»`)) act(() => api.deleteRecordCategory(c.name), (r) => `تم الحذف ونقل ${r.moved} سجل إلى «أخرى»`); };
  return (
    <div className="flex items-center gap-2" data-testid={`cat-row-${i}`}>
      <Input value={v} disabled={c.locked} onChange={(e) => setV(e.target.value)} className="h-9" data-testid={`cat-name-${i}`} />
      <span className="w-14 shrink-0 text-center text-xs text-slate-400">{c.count} سجل</span>
      {c.locked ? <Lock className="h-4 w-4 shrink-0 text-slate-300" /> : (<>
        {v.trim() && v.trim() !== c.name && <Button size="icon" variant="outline" className="h-9 w-9 shrink-0" disabled={busy} onClick={rename} data-testid={`cat-save-${i}`}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Check className="h-4 w-4 text-emerald-600" />}</Button>}
        <Button size="icon" variant="ghost" className="h-9 w-9 shrink-0 text-red-500" disabled={busy} onClick={del} data-testid={`cat-del-${i}`}><Trash2 className="h-4 w-4" /></Button>
      </>)}
    </div>
  );
};

export const CategoriesManager = ({ open, onOpenChange, onChanged }) => {
  const [list, setList] = useState(null);
  const [nv, setNv] = useState("");
  const load = () => api.recordCategoriesUsage().then(setList).catch(() => setList([]));
  useEffect(() => { if (open) { setList(null); load(); } }, [open]);
  const changed = () => { load(); onChanged?.(); };
  const add = async () => {
    try { await api.addRecordCategory(nv.trim()); setNv(""); toast.success("تمت إضافة التصنيف"); changed(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الإضافة"); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent dir="rtl" className="w-[95vw] max-w-md max-h-[85vh] overflow-y-auto" data-testid="categories-manager">
        <DialogHeader className="text-start"><DialogTitle>إدارة تصنيفات المصروفات</DialogTitle>
          <DialogDescription className="text-start">إعادة التسمية تحدّث كل السجلات، والحذف ينقل سجلاته إلى «أخرى».</DialogDescription></DialogHeader>
        {!list ? <Loader2 className="mx-auto h-5 w-5 animate-spin text-slate-400" /> : (
          <div className="space-y-2">
            {list.map((c, i) => <Row key={c.name} c={c} i={i} onChanged={changed} />)}
            <div className="flex gap-2 border-t border-slate-100 pt-3">
              <Input value={nv} onChange={(e) => setNv(e.target.value)} placeholder="تصنيف جديد" className="h-9" data-testid="cat-new-input" onKeyDown={(e) => e.key === "Enter" && nv.trim() && add()} />
              <Button className="h-9 gap-1" disabled={!nv.trim()} onClick={add} data-testid="cat-add-btn"><Plus className="h-4 w-4" /> إضافة</Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
